import {

    // Arrendamientos
    LegalLeasesApplies,
    LegalLeasesManagements,
    LegalFormLeasesManagements,
    LeasesCasesReceived,

    // Vehículos
    LegalVehiclesApplies,
    LegalVehiclesCredits,
    LegalFormVehiclesManagement,
    LegalVehiclesManagements,
    LegalVehiclesSales,

    // Others
    Expenses,
    Rates,
    ConsigningAuthorities,
    ProcessType,
    Locations,


    // Judicial Premises
    PaymentReception,
    JudicialPremises,
    PremisesManagements,

    // Timbres,
    Stamps,
    StampsLogs,

    // Abogacia y Notariado
    LegalDocuments,
    LawyerProcessesFinished,
    Lawyer,
    LawyerPayments,
    LawyerManagements,

    LegalCreditsApplies,
    LegalCreditsManagements,
    LegalFormCreditsManagement,
    LegalCredits,

} from "components/Legal";

const routesLegal = [

    {
        path: null,
        name: "Arrendamientos",
        icon: "nc-icon nc-paper",
        component: null,
        permissions: ['112_ARRENDAMIENTOS'],
        layout: null,
        visibility: true,
        subRoutes: [
            {
                path: "/juridico/arrendamientos/solicitudes",
                name: "Solicitudes",
                icon: "nc-icon nc-paper",
                component: <LegalLeasesApplies />,
                permissions: ['115_ARRENDAMIENTOS_SOLICITUDES'],
                layout: "/app",
                visibility: true,
                subRoutes: [],
            },
            {
                path: "/juridico/arrendamientos/gestiones",
                name: "Otras gestiones",
                icon: "nc-icon nc-paper",
                component: <LegalLeasesManagements />,
                permissions: ['116_ARRENDAMIENTOS_GESTIONES'],
                layout: "/app",
                visibility: true,
                subRoutes: [],
            },
            {
                path: "/juridico-arrendamientos-gestiones-form",
                name: "Formulario Gestiones",
                icon: "nc-icon nc-paper",
                component: <LegalFormLeasesManagements />,
                permissions: ['116_ARRENDAMIENTOS_GESTIONES'],
                layout: "/app",
                visibility: false,
                subRoutes: [],
            },
            {
                path: "/juridico-arrendamientos-gestiones-form/edit/:idgestion",
                name: "Formulario Gestiones",
                icon: "nc-icon nc-paper",
                component: <LegalFormLeasesManagements />,
                permissions: ['116_ARRENDAMIENTOS_GESTIONES'],
                layout: "/app",
                visibility: false,
                subRoutes: [],
            },
            {
                path: "/juridico-arrendamientos-gestiones-form/info/:idgestion",
                name: "Formulario Gestiones",
                icon: "nc-icon nc-paper",
                component: <LegalFormLeasesManagements />,
                permissions: ['116_ARRENDAMIENTOS_GESTIONES'],
                layout: "/app",
                visibility: false,
                subRoutes: [],
            },
            {
                path: "/juridico-arrendamientos-casos-recibidos",
                name: "Casos recibidos",
                icon: "nc-icon nc-paper",
                component: <LeasesCasesReceived />,
                permissions: ['117_ARRENDAMIENTOS_CASOS_RECIBIDOS'],
                layout: "/app",
                visibility: true,
                subRoutes: [],
            },
        ],
    },
    {
        path: null,
        name: "Vehículos",
        icon: "nc-icon nc-paper",
        component: null,
        permissions: ['118_VEHICULOS'],
        layout: null,
        visibility: true,
        subRoutes: [
            {
                path: "/legal-vehiculos-ventas",
                name: "Ventas",
                icon: "nc-icon nc-paper",
                component: <LegalVehiclesSales />,
                permissions: ['119_VEHICULOS_VENTAS'],
                layout: "/app",
                visibility: true,
                subRoutes: [],
            },
            {
                path: "/legal-vehiculos-creditos",
                name: "Creditos",
                icon: "nc-icon nc-paper",
                component: <LegalVehiclesCredits />,
                permissions: ['205_VEHICULOS_CREDITOS'],
                layout: "/app",
                visibility: true,
                subRoutes: [],
            },
            {
                path: "/juridico-vehiculos-solicitudes",
                name: "Solicitudes",
                icon: "nc-icon nc-paper",
                component: <LegalVehiclesApplies />,
                permissions: ['120_VEHICULOS_SOLICITUDES'],
                layout: "/app",
                visibility: true,
                subRoutes: [],
            },
            {
                path: "/juridico-vehiculos-gestiones",
                name: "Gestiones",
                icon: "nc-icon nc-paper",
                component: <LegalVehiclesManagements />,
                permissions: ['121_VEHICULOS_GESTIONES'],
                layout: "/app",
                visibility: true,
                subRoutes: [],
            },
            {
                path: "/juridico-gestiones-form",
                name: "Formulario Gestiones",
                icon: "nc-icon nc-paper",
                component: <LegalFormVehiclesManagement />,
                permissions: ['121_VEHICULOS_GESTIONES'],
                layout: "/app",
                visibility: false,
                subRoutes: [],
            },
            {
                path: "/juridico-gestiones-form/edit/:idgestion",
                name: "Formulario Gestiones",
                icon: "nc-icon nc-paper",
                component: <LegalFormVehiclesManagement />,
                permissions: ['121_VEHICULOS_GESTIONES'],
                layout: "/app",
                visibility: false,
                subRoutes: [],
            },
            {
                path: "/juridico-gestiones-form/info/:idgestion",
                name: "Formulario Gestiones",
                icon: "nc-icon nc-paper",
                component: <LegalFormVehiclesManagement />,
                permissions: ['121_VEHICULOS_GESTIONES'],
                layout: "/app",
                visibility: false,
                subRoutes: [],
            },
        ],
    },
    {
        path: null,
        name: "Creditos",
        icon: "nc-icon nc-paper",
        component: null,
        permissions: ['123_CREDITOS'],
        layout: null,
        visibility: true,
        subRoutes: [
            {
                path: "/juridico-creditos",
                name: "Creditos",
                icon: "nc-icon nc-paper",
                component: <LegalCredits />,
                permissions: ['237_CREDITOS'],
                layout: "/app",
                visibility: true,
                subRoutes: [],
            },
            {
                path: "/juridico-creditos-solicitudes",
                name: "Solicitudes",
                icon: "nc-icon nc-paper",
                component: <LegalCreditsApplies />,
                permissions: ['124_CREDITOS_SOLICITUDES'],
                layout: "/app",
                visibility: true,
                subRoutes: [],
            },
            {
                path: "/juridico-creditos-gestiones",
                name: "Gestiones",
                icon: "nc-icon nc-paper",
                component: <LegalCreditsManagements />,
                permissions: ['125_CREDITOS_GESTIONES'],
                layout: "/app",
                visibility: true,
                subRoutes: [],
            },
            {
                path: "/juridico-creditos-gestiones-form",
                name: "Formulario Gestiones",
                icon: "nc-icon nc-paper",
                component: <LegalFormCreditsManagement />,
                permissions: ['125_CREDITOS_GESTIONES'],
                layout: "/app",
                visibility: false,
                subRoutes: [],
            },
            {
                path: "/juridico-creditos-gestiones-form/edit/:idgestion",
                name: "Formulario Gestiones",
                icon: "nc-icon nc-paper",
                component: <LegalFormCreditsManagement />,
                permissions: ['125_CREDITOS_GESTIONES'],
                layout: "/app",
                visibility: false,
                subRoutes: [],
            },
            {
                path: "/juridico-creditos-gestiones-form/info/:idgestion",
                name: "Formulario Gestiones",
                icon: "nc-icon nc-paper",
                component: <LegalFormCreditsManagement />,
                permissions: ['125_CREDITOS_GESTIONES'],
                layout: "/app",
                visibility: false,
                subRoutes: [],
            },
        ],
    },
    {
        path: null,
        name: "Catalogos",
        icon: "nc-icon nc-paper",
        component: null,
        permissions: ['212_CATALOGOS'],
        layout: null,
        visibility: true,
        subRoutes: [
            {
                path: "/juridico/tarifas",
                name: "Tarifas",
                icon: "nc-icon nc-paper",
                component: <Rates />,
                permissions: ['213_TARIFAS'],
                layout: '/app',
                visibility: true,
                subRoutes: [],
            },
            {
                path: "/juridico/autoridades",
                name: "Autoridades",
                icon: "nc-icon nc-paper",
                component: <ConsigningAuthorities />,
                permissions: ['214_AUTORIDADES'],
                layout: '/app',
                visibility: true,
                subRoutes: [],
            },
            {
                path: "/juridico/gastos",
                name: "Gastos",
                icon: "nc-icon nc-paper",
                component: <Expenses />,
                permissions: ['215_GASTOS'],
                layout: '/app',
                visibility: true,
                subRoutes: [],
            },
            {
                path: "/juridico/tipos-de-proceso",
                name: "Tipos de proceso",
                icon: "nc-icon nc-paper",
                component: <ProcessType />,
                permissions: ['216_TIPOS_DE_PROCESO'],
                layout: '/app',
                visibility: true,
                subRoutes: [],
            },
            {
                path: "/juridico/ubicaciones",
                name: "Ubicaciones",
                icon: "nc-icon nc-paper",
                component: <Locations />,
                permissions: ['228_UBICACIONES'],
                layout: '/app',
                visibility: true,
                subRoutes: [],
            },
        ],
    },
    {
        path: null,
        name: "Timbres",
        icon: "nc-icon nc-paper",
        component: null,
        permissions: ['217_TIMBRES'],
        layout: null,
        visibility: true,
        subRoutes: [
            {
                path: "/juridico/timbres",
                name: "Timbres",
                icon: "nc-icon nc-paper",
                component: <Stamps />,
                permissions: ['218_TIMBRES'],
                layout: '/app',
                visibility: true,
                subRoutes: [],
            },
            {
                path: "/juridico/timbres-control",
                name: "Control",
                icon: "nc-icon nc-paper",
                component: <StampsLogs />,
                permissions: ['219_CONTROL'],
                layout: '/app',
                visibility: true,
                subRoutes: [],
            },
        ],
    },
    {
        path: null,
        name: "Abogacia & Notariado",
        icon: "nc-icon nc-paper",
        component: null,
        permissions: ['220_ABOGACIA_&_NOTARIADO'],
        layout: null,
        visibility: true,
        subRoutes: [
            {
                path: "/juridico/procesos-finalizados",
                name: "Procesos Finalizados",
                icon: "nc-icon nc-paper",
                component: <LawyerProcessesFinished />,
                permissions: ['221_PROCESOS'],
                layout: '/app',
                visibility: true,
                subRoutes: [],
            },
            {
                path: "/juridico/procesos-activos",
                name: "Procesos Activos",
                icon: "nc-icon nc-paper",
                component: <Lawyer />,
                permissions: ['221_PROCESOS'],
                layout: '/app',
                visibility: true,
                subRoutes: [],
            },
            {
                path: "/juridico/procesos/pagos/:idlawyer",
                name: "Pagos de procesos",
                icon: "nc-icon nc-paper",
                component: <LawyerPayments />,
                permissions: ['221_PROCESOS'],
                layout: '/app',
                visibility: false,
                subRoutes: [],
            },
            {
                path: "/juridico/documentos",
                name: "Documentos",
                icon: "nc-icon nc-paper",
                component: <LegalDocuments />,
                permissions: ['222_DOCUMENTOS'],
                layout: '/app',
                visibility: true,
                subRoutes: [],
            },
            {
                path: "/juridico/procesos/gestiones",
                name: "Gestiones",
                icon: "nc-icon nc-paper",
                component: <LawyerManagements />,
                permissions: ['232_GESTIONES'],
                layout: '/app',
                visibility: true,
                subRoutes: [],
            },
        ],
    },
    {
        path: null,
        name: "Predio Judicial",
        icon: "nc-icon nc-paper",
        component: null,
        permissions: ['223_PREDIO_JUDICIAL'],
        layout: null,
        visibility: true,
        subRoutes: [
            {
                path: "/juridico/predio-judicial/recepcion-de-vehiculos",
                name: "Recepción de vehículos",
                icon: "nc-icon nc-paper",
                component: <JudicialPremises />,
                permissions: ['229_RECEPCION_DE_VEHICULOS'],
                layout: '/app',
                visibility: true,
                subRoutes: [],
            },
            {
                path: "/juridico/predio-judicial/gestiones",
                name: "Gestiones",
                icon: "nc-icon nc-paper",
                component: <PremisesManagements />,
                permissions: ['230_GESTIONES'],
                layout: '/app',
                visibility: true,
                subRoutes: [],
            },
        ],
    },
    {
        path: "/juridico/predio-judicial/pagos/:idreception",
        name: "Pagos por predio judicial",
        icon: "nc-icon nc-paper",
        component: <PaymentReception />,
        permissions: ['229_RECEPCION_DE_VEHICULOS'],
        layout: '/app',
        visibility: false,
        subRoutes: [],
    },

];

export {
    routesLegal
}